import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
    UnmatchedAccountsColumns,
    qarManagersOptions,
} from "../../helper/constants";
import QarResponsibleManager from "./QarResponsibleManager";
import Grid from "@material-ui/core/Grid";
import { exportCsv } from '../Reporting/Constants';

const QarAllUnmatchedAccounts = inject("RootStore")(
    observer(({ RootStore, props }) => {
        useEffect(() => {
            RootStore.qarStore.getAllManagers();
            RootStore.qarStore.getAllUnmatchedAccounts();
        }, []);

        const tableName = `Not Recognized Accounts`;

        const tableOptions = {
            ...qarManagersOptions, exportCsv
        }

        return (
            <MaterialTable
                title=""
                data={RootStore.qarStore.unmatchedAccounts}
                options={tableOptions}
                columns={[
                    {
                        title: "Account",
                        field: "account.name",
                        render: (rowData) => rowData.account.name
                    },
                    ...UnmatchedAccountsColumns,
                    {
                        title: "Set responsible manager",
                        field: "responsibleManagerId",
                        align: "center",
                        width: "100%",
                        render: (rowData) => (
                            <QarResponsibleManager accountData={rowData} />
                        ),
                        customFilterAndSearch: (term, rowData) => {
                            return rowData.responsibleManager?.names.toLowerCase().indexOf(term.toLowerCase()) !== -1;
                        }
                    }
                ]}
                components={{
                    Toolbar: (tableProps) => (
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={3}
                        >
                            <Grid item sm={4} style={{ textAlign: 'left' }}>
                                <MTableToolbar {...tableProps} />
                            </Grid>
                        </Grid>
                    )
                }}
            />
        );
    })
);

export default QarAllUnmatchedAccounts;
